module.exports = __webpack_public_path__ + "img/logo-blanco.7a57cafc.png";